import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import StrikeZonePattern from '@mlb/react-patterns/components/StrikeZone/strikeZone';

const PitchZone = styled(StrikeZonePattern)`
    margin: 0 auto 10px;
`;

const StrikeZone = (props) => {

    const {
        fields,
        onChange,
        componentConfig,
    } = props;
    const {
        selected,
        ...field
    } = fields[0];

    const onChangeHandler = (data) => {

        const {
            event,
            changes,
            selected: newSelected,
        } = data;

        onChange({
            changes,
            selected: newSelected,
            event,
        }, field);

    };

    return (
        <PitchZone
            selected={selected}
            altText={componentConfig.altText}
            handlers={{
                onChange: onChangeHandler,
            }}
            width={'206px'}
            selectable
            pitcherView
        />
    );

};

StrikeZone.propTypes = {
    onChange: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            selected: PropTypes.array.isRequired,
        }).isRequired
    ).isRequired,
    componentConfig: PropTypes.shape({
        altText: PropTypes.string.isRequired,
    }).isRequired,
};

export default StrikeZone;
